export default {
  route: {
    '密码计算': 'Password Calculator',
    '公告': 'Announcement',
    '公告详情': 'Announcement Details',
    '在线考试': 'Online Test',
    '考试记录': 'Test Records',
    '证书信息': 'Certificate Information',
    '证书统计': 'Certificate Statistics',
    '公告管理': 'Announcement',
    '培训视频': 'Training Video',
    '培训视频管理': 'Training Video',
    '视频标签管理': 'Video Tag',
    '设备信息': 'Device Information',
    '经销商信息': 'Distributor Information',
    '经销商-设备': 'Distributor-device',
    '经销商-设备关联': 'Distributor-device Association',
    '设备关联': 'Device Association',
    '经销商-账号关联': 'Distributor-account Association',
    '系统字典': 'System Dictionary',
    '算号记录': 'Calculation Records',
    '账户管理': 'Account',
    '用户管理': 'User Management',
    '组织管理': 'Organization Management',
    '角色管理': 'Role Management',
    '功能管理': 'Function Management',
    '技术文档资料库': 'Technical Document Library',
    '员工权限': 'Staff Permissions',
    '题库管理': 'Test Bank Management',
    '单选题库管理': 'MCQ-Single',
    '多选题库管理': 'MCQ-More',
    '判断题库管理': 'True-False',
    '考试培训': 'Training&Test',
    '系统管理': 'System Management'
  },
  lang: {
    '认证经销商服务平台': 'Authorized Contractor Support Platform',
    '用户名': 'Username',
    '密码': 'Password',
    '登录': 'Enter',
    '当前版本': 'Current Version',
    '请输入用户名': 'Please enter your username',
    '请输入密码': 'Please enter your password',
    '您的密码强度太低，请尽快修改密码': 'Your password security level is too low, please change it as soon as possible',
    '修改密码': 'Change Password',
    '修改头像': 'Modify Avatar',
    '原始密码': 'Original Password',
    '新密码': 'New Password',
    '可选择': 'Optional',
    '确认新密码': 'Confirm new password',
    '请输入原始密码': 'Please enter the original password',
    '两次输入密码不一致': 'The passwords entered twice are inconsistent',
    '请输入新密码': 'Please enter the new password',
    '请输入不少于6位的密码': 'Please enter a password of no less than 6 digits',
    '修改成功,请重新登录!': 'The modification is successful, please log in again!',
    '修改失败!': 'Failed to modify!',
    '请上传正确的图片格式（jpge/jpg/png/gif）': 'Pleae upload the correct picture format（jpge/jpg/png/gif）',
    '图片大小超过1M，请重新选择!': 'The size of the picture is more than 1M, please select it again!',
    '图片命名中包含特殊字符，请规正命名再上传!': 'The picture contains special characters, please rename it and upload again!',
    '请选择头像上传': 'Please select an avatar to upload',
    '更改头像成功!': 'Change the avatar successfully!',
    '更改头像失败!': 'Failed to change avatar!',
    '取消': 'Cancel',
    '确认': 'Confirm',
    '操作': 'Operation',
    '编辑': 'Edit',
    '启用中': 'Enabled',
    '禁用中': 'Disabled',
    '编辑菜单': 'Edit Menus',
    '编辑功能': 'Edit Functions',
    '添加功能': 'Add Function',
    '您已修改状态为 --> 禁用': 'You have modified the status to  --> disabled',
    '您已修改状态为 --> 启用': 'You have modified the status to  --> enabled',
    '添加成功': 'Added successfully',
    '添加失败': 'Failed to add',
    '编辑成功': 'Edited successfully',
    '编辑失败': 'Failed to edit',
    '请选择': 'Please select',
    '状态': 'Status',
    '作废': 'Cancel',
    '功能': 'Function',
    '请输入功能名称': 'Please enter the function name',
    '功能名': 'Function Name',
    '请输入功能': 'Please enter the function description',
    '功能url': 'Function Url',
    '请输入功能url': 'Please enter the function url',
    '菜单/功能': 'Menus/Function',
    '菜单': 'Menus',
    '请输入菜单': 'Please enter menus',
    '菜单名': 'Menu Name',
    '请输入菜单名': 'Please enter the menu name',
    '是否必选': 'Required or Not',
    '添加菜单': 'Add Menu',
    '父级菜单': 'Parent-level Menu',
    '是': 'Y',
    '否': 'N',
    '启用': 'Enable',
    '禁用': 'Disable',
    '状态修改失败': 'Failed to modify the status',
    '请选择功能': 'Please select the function',
    '查询': 'Search',
    '添加': 'Add',
    '组织': 'Organization',
    '父级组织': 'Parent-level Organization',
    '请输入组织名称': 'Please enter the organization name',
    '类型': 'Type',
    '地址': 'Address',
    '添加组织': 'Add Organization',
    '编辑组织': 'Edit Organization',
    '名称': 'Name',
    '该组织名称已存在': 'The name of the organization already exists',
    '获取组织根节点列表失败': 'Failed to get the list of organization root nodes',
    '请选择组织': 'Please select an organization',
    '角色': 'Role',
    '请输入角色名称': 'Please enter the role name',
    '序号': 'Seiral Number',
    '所属组织': 'Affiliated Organization',
    '请输入': 'Please enter',
    '输入用户名': 'Please enter Username',
    '重置密码': 'Reset Password',
    '姓名': 'Name',
    '确认密码': 'Confirm Password',
    '邮箱': 'E-mail Address',
    '用户名中不能有空格': 'There should be no spaces in the username',
    '请输入不少于4位的用户名': 'Please enter a user name of no less than 4 digits',
    '该用户名已存在': 'This username already exists',
    '请输入姓名': 'Please enter name',
    '请确认密码': 'Please confirm password',
    '两次填写的密码不一致': 'The passwords entered twice are inconsistent',
    '请选择角色': 'Please select a role',
    '请输入正确的邮箱地址': 'Please enter a correct e-mail address',
    '创建时间': 'Created Time',
    '最近修改时间': 'Latest Modification Time',
    '最近登录时间': 'Latest Login Time',
    '识别码': 'Identification Number',
    '经销商编号': 'Distributor Number',
    '型号': 'Model',
    '修改时间': 'Modification Time',
    '备注': 'Remarks',
    '批量添加': 'Batch Import',
    '导出': 'Export',
    '退出登录': 'LogOut',
    '流水号': 'Serial Number',
    '流水号/注册编号': 'Serial Number/Registration',
    '请输入流水号/注册编号': 'Please enter the serial number/registration',
    '绑定密码': 'Bind Password',
    'TG密码': 'Password For【Setup】',
    '探棒设置密码': 'Password For【Probe Setup】',
    '自定义期限密码': 'Password For 【Customised Duration】',
    '永久期限密码': 'Password For 【Permanent Key】',
    '1个月密码': 'Password For 【1 Mth Effective Key】',
    '2个月密码': 'Password For 【2 Mth Effective Key】',
    '3个月密码': 'Password For 【3 Mth Effective Key】',
    '液位仪密码': 'Password For【Liquid Level Meter】',
    '请输入流水号': 'Please enter the serial number',
    '计算失败': 'Calculation failed',
    '登录失败': 'Failed to log in',
    '请先选择类型': 'Select the type first',
    '取消space': 'Cancel',
    '确定space': 'Confirm',
    '将文件拖到此处，或': 'Drag the file here，or',
    '点击上传': ' click to upload',
    '只能上传xlsx/xls文件，且不超过500kb': 'Only xlsx/xls files can be uploaded，and cannot exceed 500kb',
    '模板': 'Template',
    '保存': 'Save',
    '请输入识别码': 'Please enter the identification number ',
    '识别码已存在': 'The identification number already exists',
    '请选择型号': 'PLease select a model',
    '请选择类型': 'Please select a type',
    '确认作废此数据?': 'Confirm that this data is invalid?',
    '提示': 'Notification',
    '确定': 'Confirm',
    '作废成功': 'Successfully invalidated',
    '作废失败': 'Failed to invalidate',
    '当前限制选择 1 个文件': 'The current limit is to select a file',
    '请选择文件': 'Please select the file',
    '批量添加成功': 'Successfully batch addition',
    '批量添加失败': 'Failed to add in batches',
    '设备信息批量导入模板': 'Device Information Batch Import Template',
    '设备信息': 'Device Information',
    '关联设备url': 'Associated Device Url',
    '编号': 'Number',
    '国家或地区': 'Country or Region',
    '联系人': 'Contacts',
    '电话': 'Telephone',
    '复制': 'Copy',
    '关闭': 'Close',
    '请输入名称': 'Please enter the name',
    '名称已存在': 'The name already exists',
    '请输入国家或地区': 'Please enter the country or region',
    '获取url失败': 'Failed to obtain url',
    '复制成功': 'Successful repilication',
    '经销商信息': 'Distributor Information',
    '经销商': 'Distributor',
    '设备识别码': 'Device Identification Number',
    '审核': 'Audit',
    '审核结果': 'Audit Results',
    '审核意见': 'Audit Opinions',
    '审核备注': 'Audit Notes',
    '请选择经销商': 'Please select the distributor',
    '请选择审核结果': 'Please select the audit results',
    '请输入审核意见': 'Please enter the audit opinions',
    '同意': 'Agree',
    '不同意': 'Disagree',
    '审核成功': 'Successfully audited',
    '审核失败': 'Failed to audit',
    '有效': 'Effective',
    '失效': 'Lost Effectiveness',
    '经销商设备关联': 'Distributor device association',
    '请输入设备识别码': 'Please enter the device identification number',
    '当前账号未绑定经销商，请联系管理员绑定': 'The current account is not bound to the distributor, please contact the administrator to bind it',
    '设备关联': 'Device Association',
    '账号': 'Account',
    '请选择账号': 'Please select the account',
    '经销商账号关联': 'Distributor Account Association',
    '参数键': 'Parameter Key',
    '级参数': '-level Parameter',
    '参数值': 'Parameter Value',
    '请输入参数键': 'Please enter the parameter key',
    '参数键已存在': 'The parameter key already exists',
    '所有语言参数值 都不能为空': 'All language parameter values cannot be empty',
    '经销商名称': 'Distributor Name',
    '算号记录': 'Calculation Records',
    '操作人员': 'Operator',
    '序号不能为空': 'The serial number cannot be empty',
    '序号必须为正数': 'The serial number must be positive',
    '添加角色': 'Add Role',
    '编辑角色': 'Edit Role',
    '该角色将被删除, 是否继续?': 'The role will be deleted, whether continue?',
    '添加用户': 'Add User',
    '查询失败': 'Search Failed',
    '编辑用户': 'Edit User',
    '此操作将重置': 'This operation will reset ',
    '用户密码为': " user's password to ",
    ', 是否继续?': ', whether to continue?',
    '重置成功': 'Reset successfully',
    '重置失败': 'Reset failed',
    '已取消重置': 'The reset has been cancelled',
    '数据加载中': 'Data loading...',
    '上滑查看更多': 'Slide up to see more',
    '没有更多了': 'There is no more',
    '暂无数据': 'No data at the moment',
    '无权限': ' No Permission',
    '未登录': 'Not logged in',
    '服务器未启动/响应错误': 'Server does not start/response error',
    '菜单查询': 'Menu Inquiry',
    '设置列': 'Set The Column',
    '地址错误，请检查': 'The address is wrong, please check',
    '澳科设备认证平台': 'OKet device certification platform',
    '欢迎您使用澳科设备绑定功能': 'Welcome to the OKet device binding function',
    '绑定': 'Binding',
    '获取经销商信息失败': 'Failed to obtain distributor information',
    '未获取到经销商信息，请刷新页面': "If you don't get the distributor information, please refresh the page",
    '绑定成功': 'Binding successfully',
    '绑定失败': 'Failed to bind',
    '版权所有': 'All rights reserved',
    '青岛澳科仪器有限责任公司': 'Qingdao OKet Instrument Co., Ltd.',
    '关闭其它': 'Close Others',
    '关闭所有': 'Close All',
    '对应设备已存在': 'The corresponding device already exists',
    '文件': 'File',
    '下载': 'Download',
    '液位仪安装验收单': 'OKet Debugging Inspection Confirmation Form--Automatic tank gauge',
    '测漏安装验收单': 'OKet Debugging Inspection Confirmation Form--Leak detection system',
    '安装工具清单': 'OKet Installation Tool List',
    '维护': 'OKet Maintenance Manual',
    '操作维护指南': 'OKet Operation and daily maintenance',
    '加油站': 'Station',
    '请输入加油站': 'Please enter the station',
    '请先选择经销商': 'Select the distributor first',
    '员工': 'Staff',
    '可计算密码类型': 'Types of Password',
    '请选择员工': 'Please select the staff',
    '该员工已添加': 'The staff has been added',
    '请选择设备识别码': 'Please select the device identification number',
    '请选择可计算密码类型': 'Please select the types of password',
    '该经销商未关联用户': 'This distributor has no associated users',
    '客服销售人员': 'Customer service salesperson',
    '管理员': 'Administrator',
    '无此密码类型': 'No such password type',
    bullshit_info: 'Please check if the URL you entered is correct, please click the button below to return to the homepage or send an error report',
    return_home: 'Back to personal center',
    cant_in: "The webmaster says you can't enter this page...",
    advice: 'In order to bring you a better user experience, we strongly recommend that you use the speed mode or Chrome browser',
    // 后端
    '暂未登录或token已经过期': 'Not logged in or token has expired'
  },
  fun: {
    '公告': 'Announcement',
    '公告详情': 'Announcement Details',
    '在线考试': 'Online Test',
    '考试记录': 'Test Records',
    '证书信息': 'Certificate Information',
    '证书统计': 'Certificate Statistics',
    '公告管理': 'Announcement Management',
    '培训视频': 'Training Video',
    '培训视频管理': 'Training Video Management',
    '视频标签管理': 'Video Tag Management',
    '题库管理': 'Test Bank Management',
    '单选题库管理': 'MCQ-Single',
    '多选题库管理': 'MCQ-More',
    '判断题库管理': 'True-False',
    '用户权限': 'User rights',
    '用户管理': 'User Management',
    '组织管理': 'Organization Management',
    '角色管理': 'Role Management',
    '功能管理': 'Function Management',
    '设备信息': 'Device Information',
    '经销商信息': 'Distributor Information',
    '经销商-设备关联': 'Distributor-device Association',
    '经销商-账号关联': 'Distributor-account Association',
    '系统字典': 'System Dictionary',
    '算号记录': 'Calculation Records',
    '设备关联': 'Device Association',
    '密码计算': 'Password Calculator',
    '查询设备全部': 'Search all devices',
    'App': 'App',
    'getInfo': 'getInfo',
    '分页查询设备': 'Pagination search device',
    '添加设备信息': 'Add device information',
    '更新设备信息': 'Update device information',
    '设备作废': 'equipment obsolete',
    '设备识别码判重': 'Device identification code judgment',
    '分页查询经销商': 'Search for dealers by page',
    '查询设备经销商全部': 'Search all equipment dealers',
    '添加经销商信息': 'Add dealer information',
    '更新经销商信息': 'Update dealer information',
    '经销商信息作废': 'Distributor information is invalid',
    '经销商名称、编号判重': 'Distributor name and serial number',
    '获取当前用户的经销商': "Get current user's reseller",
    '分页查询经销商设备关联': 'Search dealer equipment association by page',
    '查询经销商设备关联全部': 'Search dealer equipment association all',
    '添加经销商设备关联信息': 'Add dealer equipment association information',
    '更新经销商设备关联信息': 'Update dealer equipment association information',
    '经销商设备关联作废': 'Reseller equipment association is invalid',
    '经销商-设备关联查询设备全部': 'Dealer-equipment association search equipment all',
    '经销商-设备关联查询设备经销商全部': 'Dealer-equipment association search all equipment dealers',
    '经销商-设备关联分页查询经销商设备关联': 'Reseller-device association page search dealer equipment association',
    '经销商-设备关联查询经销商设备关联全部': 'Dealer-Equipment Association Search Dealer Equipment Association All',
    '经销商-设备关联添加经销商设备关联信息': 'Reseller-device association Add reseller device association information',
    '经销商-设备关联更新经销商设备关联信息': 'Reseller-device association update reseller device association information',
    '经销商-设备关联经销商设备关联作废': 'Dealer-equipment associationDealer equipment association is invalid',
    '经销商设备关联审核': 'Reseller equipment association review',
    '分页查询经销商账号关联': 'Search dealer account association by page',
    '查询经销商账号关联全部': 'Search dealer account association all',
    '添加经销商账号关联信息': 'Add dealer account associated information',
    '更新经销商账号关联信息': 'Update dealer account associated information',
    '经销商账号关联作废': 'Distributor account association void',
    '经销商-账号关联获取所有得用户列表': 'Dealer-account association for a list of all users',
    '经销商-账号关联查询设备经销商全部': 'Dealer-Account Associated Search Equipment Dealers All',
    '右上角添加/修改用户': 'Add/modify users in the top right corner',
    '用户头像-上传本地': 'User avatar - upload local',
    '用户密码修改': 'User password change',
    '分页查询组织': 'Paged search organisation',
    '添加组织': 'Add organization',
    '编辑组织': 'Editorial Organisation',
    '校验组织是否存在': 'Verifying the existence of an organisation',
    '查询角色列表': 'Find a list of roles',
    '删除角色': 'Delete Role',
    '角色查询所有得权限': 'Role Search All Permissions',
    '添加/编辑角色': 'Adding/Editing Roles',
    '组织根节点列表': 'List of Organizational Root Nodes',
    '查询所有得权限': 'Check all permissions',
    '获取所有的菜单': 'Get all menus',
    '添加/编辑权限': 'Add/Edit Permissions',
    '获取所有得用户列表': 'Get a list of all users',
    '添加/修改用户': 'Adding/modifying users',
    '用户密码重置': 'User password reset',
    '用户是否存在': 'Does the user exist',
    '获取算号': 'Get the count',
    '查询全部算号': 'Search All Numbers',
    '分页查询算号': 'Paging Search Numbering',
    '获取关联设备的url': 'Get the url of the associated device',
    '分页查询系统字典项(树形)': 'Paging search system dictionary items (tree)',
    '查询所有系统字典项-列表': 'Search all system dictionary items - list',
    '查询系统字典类型': 'Search system dictionary type',
    '添加系统字典': 'Adding a system dictionary',
    '编辑系统字典': 'Editing the system dictionary',
    '查询下一级系统字典项': 'Search the next level of system dictionary entries',
    '校验参数键是否重复': 'Checks for duplicate parameter keys',
    '设备查询下一级系统字典项': 'Device search next level system dictionary item',
    '批量导入设备信息': 'Batch import device information',
    '技术文档资料库': 'Technical Document Library',
    '技术文档资料库界面': 'Technical Document Library Interface',
    '更新设备信息admin': 'Update device information admin',
    '更新设备信息noadmin': 'Update device information noAdmin',
    '员工权限': 'Staff permissions',
    '查询当前用户组织下可查看角色': 'Search the available roles under the current user organization',
    '查询算号记录算密码类型': 'Search number calculation record calculation password type',
    '查询密码计算算密码类型': 'Search password calculation calculate password type',
    '查询当前用户角色': 'Search the current user role',
    '查询员工权限算密码类型': 'Search employee authority and calculate password type',
    '分页查询员工权限': 'Search employee permissions by page',
    '查询员工权限全部': 'Search all employee permissions',
    '添加员工权限': 'Add employee permissions',
    '编辑员工权限': 'Edit employee permissions',
    '校验经销商员工关系是否唯一': 'Verify that the dealer employee relationship is unique',
    '员工权限作废': 'Employee authority void',
    '查询指定用户组织下的用户': 'Search the users under the specified user organization',
    '员工权限查询经销商设备关联全部': 'Employee permission search Dealer equipment association all',
    '员工权限获取所有得用户列表': 'Employee permission to get all user lists',
    '员工权限获取当前用户的经销商': "Employee Permissions Get current user's resellers",
    '员工权限查询设备经销商全部': 'Employee permission search equipment dealers all',
    '员工权限查询经销商账号关联全部': 'Employee permission search Dealer account associated with all',
    '用户管理查询当前用户角色': 'User management search current user role',
    '获取全部国家和地区': 'Get all countries and regions',
    '公告分页': 'Announcement Page',
    '阅读公告': 'Read Announcement',
    '公告（详情）': 'Announcement (details)',
    '公告分页（管理）': 'Announcements Tab (management)',
    '添加公告': 'Add Announcement',
    '编辑公告': 'Edit Announcement',
    '删除公告': 'Delete Announcement',
    '新增试卷（考试）': 'New Test Paper (test)',
    '试卷内容': 'Test Paper Content',
    '提交试卷': 'Submit Test Paper',
    '试卷分页（考试记录）': 'Pagination of test papers (test records)',
    '用户列表': 'User List',
    '新增试卷': 'New Test Paper',
    '证书分页': 'Certificate Pagination',
    '用户列表（证书）': 'User List (certificate)',
    '培训视频分页': 'Training Videos Pagination',
    '培训视频标签分页（视频）': 'Training Videos Tab Pagination (videos)',
    '培训视频分页（管理）': 'Training Videos Pagination (Management)',
    '添加培训视频': 'Add Training Video',
    '编辑培训视频': 'Edit Training Video',
    '删除培训视频': 'Delete Training Video',
    '培训视频标签分页（管理）': 'Training Videos Tab Pagination (Management)',
    '培训视频标签分页': 'Training Videos Tab Pagination',
    '添加培训视频标签': 'Add Training Video Tag',
    '编辑培训视频标签': 'Edit Training Video Tags',
    '删除培训视频标签': 'Remove Training Video Tags',
    '题目列表分页(单选)': 'Topic List Pagination (MCQ-Single)',
    '新增题目（单选）': 'Add A Topic (MCQ-Single)',
    '删除题目（单选）': 'Delete Topic (MCQ-Single)',
    '题目列表分页（多选）': 'Topic List Pagination (MCQ-More)',
    '新增题目（多选）': 'Add A Topic (MCQ-More)',
    '删除题目（多选）': 'Delete Topic (MCQ-More)',
    '题目列表分页（判断）': 'Topic List Pagination (judgment)',
    '新增题目（判断）': 'Add New Topic (judgment)',
    '删除题目（判断）': 'Delete Topic (judgment)',
    '考试培训': 'Training&Test',
    '系统管理': 'System Management',
    '证书下载': 'Certificate Download',
    '证书下载（考试记录）': 'Certificate Download(test record)',
    '证书分页（统计）': 'Certificate Pagination (Statistics)',
    '用户列表（统计）': 'User List (Statistics)',
    '证书下载（统计）': 'Certificate Download (Statistics)'
  },
  file: {
    'ATG系列文档': 'ATG Series Documents',

    'ATG操作手册': 'ATG Operation Manual',
    '1-1-3-1-1': "1-1-3-1-1 PD-350+ Networking Tank-eye Operator's Manual V1.5-20250528",
    '1-1-3-1-2': '1-1-3-1-2 PD-350 & PD-350+ Series Console Operator’s Manual 20250520',
    '1-1-3-1-4': '1-1-3-1-4 MC-6 Explosion proof Console Operator’s Manual V2.0',
    '1-1-3-1-5': '1-1-3-1-5 OKet Console Quick Start Guide (20250519)',
    '1-1-3-1-6': '1-1-3-1-6 OKet Guide de Démarrage 20250522',
    '1-1-3-1-7': '1-1-3-1-7 OKet Guía de Inicio Rápido_',

    'ATG改造和安装指南': 'ATG Retrofit And Installation Guide',
    '1-1-4-2-1': '1-1-4-2-1 Automatic Tank Gauge for DEF tanks Installation Guide',
    '1-1-4-2-2': '1-1-4-2-2 Automatic Tank Gauge for LPG tanks Installation Guide',
    '1-1-4-2-3': '1-1-4-2-3 Wired ATG Installation Guide-20251125',
    '1-1-4-2-4': '1-1-4-2-4 Automatic Tank Gauge Installation Guide',
    '1-1-4-2-6': '1-1-4-2-6 Guidance for changing the ATGs grounding method to the single tank shielding layer grounding method',
    '1-1-4-2-7': '1-1-4-2-7 Automatic Tank Gauges Probe Installation Guide for Lubricant',
    '1-1-4-2-8': '1-1-4-2-8 Wireless ATG Installation Guide-20250930',
    '1-1-4-2-9': '1-1-4-2-9 The operation of installing the button cell',
    '1-1-4-2-10': '1-1-4-2-10 Differential pressure level gauge installation and operation guide V1.1-20240829 EN',
    '1-1-4-3-1-1': '1-1-4-3-1-1 Probe length calculation drawing',
    '1-1-4-3-1-2': '1-1-4-3-1-2 Probe length table',
    '1-1-4-3-2-2': '1-1-4-3-2-2 Wired ATG Field Construction and Retrofit Guide',
    '1-1-4-3-2-3': '1-1-4-3-2-3 Wireless ATG Field Construction and Retrofit Guide V1.0 20250415',
    'B——3': "B——3'' B-type riser cover(NPT pipe thread)-Model",
    'N——3': "N——3'' N-type riser cover(G pipe thread)-Model",
    'riser': 'riser cap-2024.11.06',

    'ATG维护指南': 'ATG Maintenance And Troubleshooting',
    '1-1-7-6-1': '1-1-7-6-1 ATG Maintenance Guide',
    '1-1-7-6-2': '1-1-7-6-2 ATG Troubleshooting Guide',
    '1-1-3-5-2': '1-1-3-5-2 ATG Daily Operations and Maintenance  (pdf)',
    '1-1-3-5-3': '1-1-3-5-3 Automatic Tank Gauges Usage Guidelines',
    '1-1-9-1-1': '1-1-9-1-1 OKet PD-350 Series Consoles Troubleshooting Manual（20230807）',

    'LD系列文档': 'LDS Series Documents',

    'LD操作手册：请参考《ATG操作手册》LD改装及安装指南': 'LDS Operation Manual：Please refer to 《ATG Operation Manual》 LDS Retrofit and Installation Guide',

    'LD改造和安装指南': 'LDS Retrofit And Installation Guide',
    '1-2-4-1-1': '1-2-4-1-1 Dispenser Pan Leak Detection Sensor Installation Guide DPLS-1 and DPLS-2C',
    '1-2-4-1-2': '1-2-4-1-2 Double-wall tank gap leak Detection sensor Installation Guide SFLS-2F',
    '1-2-4-1-3': '1-2-4-1-3 Double Wall Pipeline Leak Detection Sensor Installation Guide DLLS-2DA and DLLS-2C ',
    '1-2-4-1-4': '1-2-4-1-4 FRP-Steel Double-wall Tank Leak Detection Sensor Installation Guide SFLS-2DA SFLS-2C ',
    '1-2-4-1-5': '1-2-4-1-5 FRP Double-wall Tank Leak  Detection Sensor Installation Guide HLS-1D',
    '1-2-4-1-6': '1-2-4-1-6 Manhole Well Leak Detection Sensor Installation Guide--CSLS-1',
    '1-2-4-1-7': '1-2-4-1-7 Tank Containment Sump Leak Detection Sensor Installation Guide---FSLS-1',
    '1-2-4-1-9': '1-2-4-1-9 Tank vacuum leak sensor installation guide---vtls-1',

    'LD维护指南': 'LDS Maintenance Guide',
    '1-2-7-1': '1-2-7-1 Leak Sensor Modification Address Operation Instructions',

    'HSSE要求': 'HSSE Requirements',
    'OKet HSSE管理体系要求V202306': 'OKet HSSE Management System Requirements V202306',

    '工具清单和收据模板': 'Tool List And Receipt Template',
    '1-1-4-4-1': '1-1-4-4-1 Installation Tool List for ATG and LDS',
    '1-1-4-4-2': '1-1-4-4-2 Automatic Tank Gauges Installation Acceptance Form ',
    '1-1-5-1-1': "1-1-5-1-1 OKet's ATG Order needs to be clear",
    '1-1-5-1-2': "1-1-5-1-2 OKet's ATG Order needs to be clear（wireless)",
    '1-1-5-2-1': '1-1-5-2-1 ATG 2 inches Packing List & Acceptance Form',
    '1-1-5-2-2': '1-1-5-2-2 ATG 3 inches Packing List & Acceptance Form',
    '1-1-5-2-3': '1-1-5-2-3 ATG(wireless) Packing List & Acceptance Form',
    '1-2-5-1-1': '1-2-5-1-1 CSLS-1 Packing List & Acceptance Form',
    '1-2-5-1-2': '1-2-5-1-2  Packing List & Acceptance Form',
    '1-2-5-1-3': '1-2-5-1-3  DPLS-1 Packing List & Acceptance Form',
    '1-2-5-1-4': '1-2-5-1-4  FSLS-1Packing List & Acceptance Form',
    '1-2-5-2': '1-2-5-2 Leak Detection Integrated Installation Acceptance Form '
  },
  exam: {
    '题目': 'Topic',
    '题目类别': 'Topic Category',
    '题目答案': 'Topic Answer',
    '答案解析': 'Answer Analysis',
    '暂无解析': 'No Resolution Yet',
    '序号': 'Serial Number',
    '题目内容': 'Topic Content',
    '题目配图': 'Topic Picture',
    '暂无': 'No Yet',
    '操作': 'Operate',
    '删除': 'Delete',
    '选项A': 'Option A',
    '选项B': 'Option B',
    '选项C': 'Option C',
    '选项D': 'Option D',
    '选项E': 'Option E',
    '选项F': 'Option F',
    '选项G': 'Option G',
    '添加题目': 'Add Topic',
    '编辑题目': 'Edit Topic',
    '确认添加': 'Confirm Add',
    '确认编辑': 'Confirm Edit',
    '选项A为必填项': 'Option A is required',
    '选项B为必填项': 'Option B is required',
    '选项C为必填项': 'Option C is required',
    '请选择题目类型': 'Please select a topic type',
    '题目内容为必填项': 'Topic content is required',
    '题目答案为必填项': 'Topic answer is required',
    'ATG安装': 'ATG Installation',
    'LDS安装': 'LDS Installation',
    '保存成功': 'Saved Successfully',
    '保存失败': 'Save Failed',
    '确定删除该题目吗': 'Are you sure you want to delete this Topic',
    '删除成功': 'Successfully Deleted',
    '删除失败': 'Failed To Delete',
    '正确': 'Correct',
    '错误': 'Error',
    '组织员工': 'Organize Staff',
    '员工': 'Staff',
    '证书类别': 'Certificate Type',
    '证书下载': 'Certificate Download',
    '员工列表查询失败': 'Employee list search failed',
    '资质证书': 'Certifications',
    '证书有效期': 'Certificate Validity',
    '试卷类别': 'Test Category',
    '考试结果': 'Test Result',
    '再次考试': 'Re-test',
    '合格': 'Qualified',
    '不合格': 'Unqualified',
    '生成试卷失败': 'Failed to generate test paper',
    '考试开始时间': 'Test Start Time',
    '考试结束时间': 'Test End Time',
    '考试进行中': 'Test In Progress',
    '技能类别': 'Skill Category',
    '标签中文名称': 'Label Chinese Name',
    '标签英文名称': 'Label English Name',
    '标签西班牙名称': 'Label Spanish Name',
    '标签法语名称': 'Label French Name',
    '请选择技能类别': 'Please select a skill category',
    '请输入标签中文名称': 'Please enter the Chinese name of the label',
    '请输入标签英文名称': 'Please enter the English name of the label',
    '请输入标签西班牙名称': 'Please enter the Spanish name of the label',
    '请输入标签法语名称': 'Please enter the French name of the label',
    '返回': 'Return',
    '公告标题': 'Announcement Title',
    '公告内容': 'Announcement Content',
    '公告标题(中文)': 'Announcement Title(Chinese)',
    '公告内容(中文)': 'Announcement Content(Chinese)',
    '公告标题(英文)': 'Announcement Title(English)',
    '公告内容(英文)': 'Announcement Content(English)',
    '公告标题(西班牙)': 'Announcement Title(Spanish)',
    '公告内容(西班牙)': 'Announcement Content(Spanish)',
    '公告标题(法语)': 'Announcement Title(French)',
    '公告内容(法语)': 'Announcement Content(French)',
    '请输入公告标题(中文)': 'Please enter the title of the announcement(Chinese)',
    '请输入公告内容(中文)': 'Please enter the announcement content(Chinese)',
    '请输入公告标题(英文)': 'Please enter the title of the announcement(English)',
    '请输入公告内容(英文)': 'Please enter the announcement content(English)',
    '请输入公告标题(西班牙)': 'Please enter the title of the announcement(Spanish)',
    '请输入公告内容(西班牙)': 'Please enter the announcement content(Spanish)',
    '请输入公告标题(法语)': 'Please enter the title of the announcement(French)',
    '请输入公告内容(法语)': 'Please enter the announcement content(French)',
    '发布时间': 'Release Time',
    '已读': 'Have Read',
    '未读': 'Unread',
    '记录阅读状态失败': 'Record read status failed',
    'ATG安装技师考试': 'ATG Installation Technician Test',
    'LDS安装技师考试': 'LDS Installation Technician Test',
    '参加考试': 'Take The test',
    '退出': 'Quit',
    '答题卡': 'Answer Sheet',
    '考试日期': 'Test Date',
    '考试时长': 'Test Duration',
    '分钟': 'Minutes',
    '单选题': 'MCQ-Single',
    '分': 'Points',
    '多选题': 'MCQ-More',
    '判断题': 'True-False',
    '无': 'None',
    '上一题': 'Previous Question',
    '下一题': 'Next Question',
    '提交试卷': 'Submit',
    '已完成': 'Completed',
    '每题': 'Per Question',
    '加载中': 'Loading',
    '获取试卷详情失败': 'Failed to get test details',
    '交卷时间已到，系统将帮您自动交卷': 'The time for handing in the paper is up, the system will automatically hand in the paper for you',
    '交卷失败，数据库错误，请重新开始考试': 'Submission failed, database error, please restart the test',
    '确定要提交试卷吗': 'Are you sure you want to submit this test',
    '尚未完成所有题目，确定要提交试卷吗': 'Have not completed all the questions, are you sure you want to submit this test',
    '自动计算成绩中': 'Automatically calculating grades',
    '提交成功': 'Submitted Successfully',
    '系统将自动提交试卷，请确认是否离开考试': 'The system will automatically submit this test. Please confirm if you want to leave the test',
    '退出考试，系统已自动提交试卷': 'Exit this test, the system has automatically submitted this test',
    '可到记录页面查看成绩': 'Go to the record page to view the results',
    '试卷详情': 'Test Details',
    '试卷类型': 'Paper Type',
    '全部题数': 'All Questions',
    '道': 'Questions',
    '试卷总分': 'Total Score',
    '及格标准': 'Pass Standard',
    '题型介绍': 'Question Type Introduction',
    '考试说明': 'Test Description',
    '开始考试': 'Start Test',
    '确定开始考试吗': 'Are you sure you want to start the test',
    '请开始作答': 'Please start answering',
    '视频类别': 'Video Category',
    '视频名称': 'Video Name',
    '视频封面': 'Video Cover',
    '视频文件': 'Video File',
    '视频名称(英文)': 'Video Name(English)',
    '视频封面(英文)': 'Video Cover(English)',
    '视频文件(英文)': 'Video File(English)',
    '视频名称(中文)': 'Video Name(Chinese)',
    '视频封面(中文)': 'Video Cover(Chinese)',
    '视频文件(中文)': 'Video File(Chinese)',
    '视频名称(西班牙)': 'Video Name(Spanish)',
    '视频封面(西班牙)': 'Video Cover(Spanish)',
    '视频文件(西班牙)': 'Video File(Spanish)',
    '视频名称(法语)': 'Video Name(French)',
    '视频封面(法语)': 'Video Cover(French)',
    '视频文件(法语)': 'Video File(French)',
    '请输入视频名称(英文)': 'Please enter a video name(English)',
    '请选择视频类别': 'Please select a video category',
    '全部': 'All',
    '查询视频标签数据失败': 'Failed to search video tag data',
    '图片大小不能超过2MB': 'Image size cannot exceed 2MB',
    '当前限制选择 1 个文件': 'Current limit to select 1 file',
    '点击下载': 'Click Download',
    '题型单选题': 'MCQ-Single ',
    '题型多选题': 'MCQ-More ',
    '题型判断题': 'True-False ',
    '题型道': ' Questions',
    '题型每题': ' Per Question ',
    '题型分': ' Points',
    '上传文件只能是mp4格式': 'Upload files can only be in .mp4 format',
    '请上传视频封面(英文)': 'Please upload video cover(English)',
    '请上传视频文件(英文)': 'Please upload a video file(English)',
    '上传头像图片只能是JPG/JPEG/PNG格式': 'The uploaded profile picture can only be in JPG/JPEG/PNG format',
    '下载失败': 'Download failed'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js